import React from 'react';
import AdminHeader from '../../globals/Layout/Admin/AdminHeader';
import TSources from './Tables/TSources';
const Source: React.FC = () => {
    return (
        <div>
            <AdminHeader>Agrupación de Fuente de Emisión</AdminHeader>  
            <TSources/>        
        </div>

    );
};


export default Source;